import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShiftRoutingModule } from './shift.routing';

import {NgxPaginationModule} from 'ngx-pagination';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import { UpdateShiftComponent } from './update-shift/update-shift.component';
import { AddShiftComponent } from './add-shift/add-shift.component';
import { ShiftsComponent } from './shifts/shifts.component';
// import {NoopAnimationsModule} from '@angular/platform-browser/animations';
import { ShiftDetailComponent } from './shift-detail/shift-detail.component';
import { ShiftInfoComponent } from './shift-detail/shift-info/shift-info.component';
import { DriverShiftComponent } from './shift-detail/driver-shift/driver-shift.component';
import { ShiftBatchComponent } from './shift-detail/shift-batches/shift-batch.component';

// import { NgbdTimepickerMeridian } from './timepicker-meridian';

@NgModule({
  declarations: [
  UpdateShiftComponent,
  AddShiftComponent,
  ShiftsComponent,
  ShiftDetailComponent,
  ShiftInfoComponent,
  DriverShiftComponent,
  ShiftBatchComponent,

],
  imports: [
    CommonModule,
    ShiftRoutingModule,
    NgxPaginationModule,
    FormsModule,
    ReactiveFormsModule,
    MatSortModule,
    MatTableModule,
    // NoopAnimationsModule,
  ],
})
export class ShiftModule { }
